<script>
import AlertList from '../../components/js/Components/Alert/AlertList.vue'
import Comments from '../../components/js/Components/Comment/Comments.vue'
import ContractMenu from '../../components/js/Components/Contract/ContractMenu.vue'
import ContractRestructuringList from '../../components/js/Components/ContractRestructuring/ContractRestructuringList.vue'
import LegacyContractRestructuring from '../../components/js/Components/ContractRestructuring/LegacyContractRestructuring.vue'
import Outstanding from '../../components/js/Components/Finance/Outstanding.vue'
import Profitabilities from '../../components/js/Components/Finance/Profitabilities.vue'
import BlockContent from '../../components/js/Components/UI/Content/BlockContent.vue'
import MainContainer from '../../components/js/Components/UI/Content/MainContainer.vue'
import MainContent from '../../components/js/Components/UI/Content/MainContent.vue'
import LazyContent from '../../components/js/Components/UI/Loading/LazyContent.vue'
import PlaceholderContent from '../../components/js/Components/UI/Loading/PlaceholderContent.vue'
import PageLayout from '../../components/js/Components/UI/PageLayout.vue'
import WalletContractActions from '../../components/js/Components/Wallet/WalletContractActions.vue'
import WalletContractDetail from '../../components/js/Components/Wallet/WalletContractDetail.vue'
import WalletContractDocuments from '../../components/js/Components/Wallet/WalletContractDocuments.vue'
import useSearchParams from '../../components/js/Composables/useSearchParams.js'
import { globalVariablesMixin } from '../../components/js/Mixins/global.js'
import mixinComponent from '../../components/js/Mixins/mixinComponent.js'
import { platformMixins } from '../../components/js/Mixins/platform.js'
import useContract from '../../Composables/Contract/useContract.ts'

export default {
  components: {
    BlockContent,
    PlaceholderContent,
    LazyContent,
    LegacyContractRestructuring,
    ContractRestructuringList,
    AlertList,
    Comments,
    ContractMenu,
    MainContainer,
    MainContent,
    Outstanding,
    PageLayout,
    Profitabilities,
    WalletContractActions,
    WalletContractDetail,
    WalletContractDocuments,
  },
  mixins: [mixinComponent, globalVariablesMixin, platformMixins],

  data() {
    let urlParams = new URLSearchParams(window.location.search)
    return {
      contractNumber: null,
      entityId: null,
      isLogged: urlParams.get('u') !== undefined,
      uuid: urlParams.get('u'),
      page: urlParams.get('p'),
      onglet: urlParams.get('o'),
      contractLoaded: false,
      outstandings: [],
      showAlert: false,
      alertInformation: {
        status: '',
        number: 0,
        blocking: false,
      },
    }
  },
  computed: {
    contractId() {
      const id = this.searchParams.get('i')
      if (null !== id) {
        return parseInt(id)
      }

      return null
    },
  },
  methods: {
    getUrl(url) {
      if (this.uuid) {
        url = 'free/' + url + '?uniqid=' + this.uuid
      }
      return url
    },
    changeLink(page) {
      this.page = page
    },
    showAlertList() {
      this.showAlert = !this.showAlert
    },
    alertInfo(json) {
      if (json.length > 0) {
        const alertStatus = json.map((alert) => alert.status)
        const alertBlocking = json.some((alert) => alert.type?.blocking)

        const createdAlerts = alertStatus.filter((status) => ['CREATED', 'SENT'].includes(status))

        this.alertInformation = {
          number: createdAlerts.length,
          status: alertStatus.every((status) => status === 'ARCHIVED') ? 'ARCHIVED' : 'CREATED',
          blocking: alertBlocking,
        }
      } else {
        this.alertInformation.number = 0
      }

      if (!this.alertInformation.blocking) {
        this.unblock()
      }
    },
    getAlert() {
      if (this.$refs.alertList) {
        this.$refs.alertList.loadAlert()
      }
    },
  },
  setup() {
    const { contract, isPartOfRestructuring, restructurings, unblock } = useContract()
    const { searchParams } = useSearchParams()

    return { searchParams, contract, isPartOfRestructuring, restructurings, unblock }
  },
  mounted() {
    window.addEventListener('popstate', (event) => {
      let urlParams = new URLSearchParams(window.location.search)
      this.page = urlParams.get('p')
    })
  },

  beforeMount() {
    if (this.isClient || this.isPlatform) {
      this.getJSON(this.getUrl('contracts/' + this.contractId + '/portefeuille')).then(
        (contract) => {
          this.entityId = contract.client.id
          this.contractNumber = contract.number
          this.contract = contract
          this.contractLoaded = true
        },
        (reason) => {
          alert(reason)
        },
      )

      if (this.hasRole('ROLE_OUTSTANDING_CLIENT')) {
        this.getJSON(this.getUrl('contracts/' + this.contractId + '/portefeuille/outstandings')).then(
          (outstandings) => {
            this.outstandings = outstandings
          },
        )
      }
    } else {
      window.location = '../404.php'
    }
  },
}
</script>
<template>
  <div>
    <PageLayout :menu="onglet ?? 'portefeuille-index'" :client="isClient && conf.connect_client">
      <MainContainer>
        <MainContent>
          <ContractMenu
            :contract="contract"
            :active="page"
            :alert-information="alertInformation"
            @link="changeLink"
            @show-alert="showAlertList"
          />

          <LazyContent :loading="!contract">
            <AlertList
              ref="alertList"
              v-if="hasRole('ROLE_ALERT_SHOW') && Object.entries(contract).length > 0"
              context="AppBundle\Entity\Contract"
              :context-id="Number(contractId)"
              :show="showAlert"
              :object="contract"
              @alert-info="alertInfo"
            />

            <WalletContractDetail
              v-if="contractId && page == 'detail'"
              :contract-id="Number(contractId)"
              :contract="contract"
            />
            <Outstanding
              v-if="page == 'contractOutstanding' && hasRole('ROLE_OUTSTANDING_CLIENT')"
              :outstandings="outstandings"
              :is-outstanding-supplier="contract.company?.isOutstandingSupplier ?? false"
            />
            <WalletContractDocuments
              v-if="contractId && page == 'document'"
              :contract-id="Number(contractId)"
              :company-salesman="contract.companySalesman"
            />
            <Profitabilities
              v-if="contractId && page == 'profitability'"
              :id="Number(contractId)"
              context="contracts"
              wallet
            />
            <WalletContractActions v-if="contractId && page == 'action'" :contract="contract" @call:alert="getAlert" />
            <LegacyContractRestructuring
              v-if="contractId && page == 'restructuration' && hasRole('ROLE_RESTRUCTURATION')"
              :contract-id="Number(contractId)"
              :contract-number="contractNumber"
            />
            <ContractRestructuringList
              v-if="page === 'restructuring' && hasRole('ROLE_RESTRUCTURING') && isPartOfRestructuring"
              :restructurings="restructurings"
              :contract-id="contractId"
              :loading="contractLoaded === false"
            />
            <Comments
              v-if="contractId && page == 'comments'"
              :simulation-id="contract.simulationId"
              :contract-id="contractId"
            />

            <template #loader>
              <BlockContent>
                <div class="row">
                  <div class="col-6">
                    <PlaceholderContent :rows="4" />
                  </div>
                  <div class="col-6">
                    <PlaceholderContent :rows="4" />
                  </div>
                </div>
              </BlockContent>
            </template>
          </LazyContent>
        </MainContent>
      </MainContainer>
    </PageLayout>
  </div>
</template>
